import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";

export default function getOperatorDisplayName(operator: OperatorApplicationApi.OperatorGetParamsOperatorOpenApiModel): string {
    let result = operator.fio;
    if (OperatorAccountStore.data.value.accessRights.canViewOperatorsLogin) {
        result += ` (${operator.login})`;
    }
    return result;
}
